import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize';
import AreaConversionListItem from './AreaConversionListItem';
import ChangeLocationService from '../../../../services/ChangeLocationService';
import { Title, Subtitle, BackButton, ConfirmModal } from '../../../../components/UI/ComponentsUI';
import ListPagination from '../../../../components/UI/ListPaginationUlNew';
import * as physicalConfirmationAction from '../../../../actions/physicalConfirmationAction';
import { translate } from '../../../../utils/util';

const AreaConversionList = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [refresh, setRefresh] = useState(0);
    const [areaConversions, setAreaConversions] = useState([]);

    useEffect(() => {
        if (props.areaConversions?.items?.length > 0) {
            if (areaConversions.length > 0 && currentPage === 0) {
                setAreaConversions(props.areaConversions.items);
            } else {
                setAreaConversions((prevState) => ([...prevState, ...props.areaConversions.items]));
            }
        } else {
            setAreaConversions([]);
        }

        // eslint-disable-next-line
    }, [props?.areaConversions?.items]);

    useEffect(() => {
        props.getAreaConversions({}, {
            PageSize: 15,
            PageIndex: currentPage
        });

        // eslint-disable-next-line
    }, [currentPage, refresh]);

    const onDelete = (id) => {
        props.deleteAreaConversion(id, () => {
            setCurrentPage(0)
            setRefresh(refresh + 1);
        })
    }

    const showMessageModal = () => {
        const modal = M.Modal.init(document.getElementById('confirmModal'));
        modal.open();
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check-outline" label="Área de Conversão" />
                    <Subtitle icon="build" label="Lista" />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div id="Listareaconversion">
                    <ListPagination
                        page={props.areaConversions?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={areaConversions.map((item, index) => {
                            return (
                                <AreaConversionListItem
                                    key={`oi-${index}`}
                                    route={{ pathname: '../areaconversion/insert', state: { update: true } }}
                                    data={item}
                                    onClickEdit={(item) => {
                                        props.setAreaConversion(item)
                                        props.history.push({
                                            pathname: '../areaconversion/insert',
                                            state: { update: true }
                                        }
                                        )
                                    }} onClickDelete={(id) => {
                                        props.setAreaConversion(item)
                                        showMessageModal()
                                    }}
                                />
                            );
                        })}
                    />
                </div>
            </div>
            <ConfirmModal
                id="confirmModal"
                data={{ title: translate('attention', 'validations'), message: translate('confirmation-delete', 'physical-confirmation') }}
                onConfirm={() => onDelete(props.areaConversion.id)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        areaConversion: state.physicalConfirmationReducer.areaConversion,
        areaConversions: state.physicalConfirmationReducer.areaConversions
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAreaConversions: (filter, pagination) => {
            dispatch(ChangeLocationService.getAreasConversions(filter, pagination));
        },
        deleteAreaConversion: (id, callback) => {
            dispatch(ChangeLocationService.deleteAreaConversion(id, callback));
        },
        setAreaConversion: (area) => {
            dispatch(physicalConfirmationAction.setAreaConversion(area));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AreaConversionList));
